if(!customElements.get('model-option')) {
    class ModelOption extends HTMLElement {
        constructor() {
            super();
            this.init();
        }
        init(){
            this.onBackOrderSelectedSVG = `<svg class="on-backorder-selected" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>`
            this.lowStockSelectedSVG = `<svg class="low-stock-selected" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>`
            this.inStockSelectedSVG = `<svg class="in-stock-selected" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>`
            this.sku = this.querySelector('[data-sku]');
            this.price = this.querySelector('[data-price]');
            this.inventoryLevel = this.querySelector('.js-inventory-notice .desktop-version');
            this.inventoryLevelMobile = this.querySelector('.js-inventory-notice .mobile-version');
            // Bind to on:variant:change event for this product
            const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
            if (variantPicker) {
                variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
            }
        }

        handleVariantChange(event) {
            const product = event.detail.product;
            if (!product) return;
            const handle = product.handle;
            const isCurrentProduct = this.dataset.productHandle === handle;
            if (!isCurrentProduct) return;

            const variant = event.detail.variant;
            if(!variant) return;
            const sku = variant.sku;
            if(sku){
                this.sku.textContent = sku;
            }
            const formattedVariant = event.detail.formatted[variant.id];
            if(this.price){
                if(formattedVariant && formattedVariant.price ){
                    this.price.textContent = formattedVariant.price;
                } else {
                    this.price.textContent = '';
                }
            }

            let inventory = variant.inventory;
            let inventoryStatus;
            let inventoryLevel;
            let tooltipText;
            if(isNaN(inventory)){
                inventory = 0;
            }
            if (inventory <= 0) {
                inventoryLevel = 'none';
            } else if (inventory <= parseInt(this.dataset.thresholdVeryLow, 10)) {
                inventoryLevel = 'very_low';
            } else if (inventory <= parseInt(this.dataset.thresholdLow, 10)) {
                inventoryLevel = 'low';
            } else {
                inventoryLevel = 'normal';
            }

            if(inventoryLevel === 'none'){
                inventoryStatus = this.onBackOrderSelectedSVG;
                tooltipText = 'On backorder';
            } else if(inventoryLevel === 'very_low'){
                inventoryStatus = this.lowStockSelectedSVG;
                tooltipText = `Only ${inventory} in stock`;
            } else if(inventoryLevel === 'low'){
                inventoryStatus = this.lowStockSelectedSVG;
                tooltipText = `Only ${inventory} in stock`;
            } else {
                inventoryStatus = this.inStockSelectedSVG;
                tooltipText = `${inventory} in stock`;
            }
            if(window.innerWidth <= 678){
                this.inventoryLevelMobile.innerHTML = tooltipText;
                this.inventoryLevelMobile.dataset.inventoryLevel = inventoryLevel;
            } else {
                this.inventoryLevel.innerHTML = inventoryStatus + `<span class="tooltip-text" id="bottom">${tooltipText}</span>`;
                this.inventoryLevel.dataset.inventoryLevel = inventoryLevel;
            }

        }

    }
    customElements.define('model-option', ModelOption);
}
